<template>
  <aside class="aside-menu">
    <HaulPopup  ref="haul_detail" v-if="haul_id" :data_in="data_in" :key="componentKey"/>
  </aside>
</template>

<script>
import Callout from './Callout'
import cSwitch from './Switch'
import HaulPopup from '../views/hauls/HaulPopup'
export default {
  name: 'c-aside',
  components: {
    Callout,
    cSwitch,
    HaulPopup
  },
  data() {
    return {
      componentKey  : 0,
      data_in       : {
        id            : null,
        haul_invoice  : false,
        edit          : '',
      },
      haul_id     : null,
    };
  },
  created: function () {      
      this.$root.$on('openPopup', (id) => {
          this.haul_id  = id.id
          this.data_in  = id
          this.componentKey += 1
          document.body.classList.toggle('aside-menu-hidden', false)
      //document.body.style['overflow']='hidden'
      //document.body.getElementsByClassName('container-fluid')[0].style['overflow'] = 'auto'
      //document.body.getElementsByClassName('container-fluid')[0].style['height'] = 'calc(100vh)'
      }); 
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Aside.vue